<template>
  <!-- 侧边菜单 -->
  <div class="cns-menu-side">
    <a-menu mode="inline" theme="light" :selectedKeys="[selectedKeys]" :inlineCollapsed="collapsed">
      <a-menu-item v-for="item in sideMenus" :key="item.key" @click.capture="changeMenu(item)">
        <router-link :to="{path: item.path.indexOf('http')!== -1 ? '/home' : item.path}">
          <span>
            <!--<a-icon :type="item.icon"/>-->
            <template v-if="!collapsed">
              <svg-icon :icon-class="item.icon"/>
              <span style="padding-left: 5px;">{{item.title}}</span>
            </template>
            <template v-else>
              <svg-icon v-if="item.title!=='首页'" :icon-class="item.icon" style="font-size: 1.2rem"/>
              <span v-if="item.title==='首页'" style="margin-left: -5px" >{{item.title}}</span>
              <span v-else style="padding-left: 5px;color: #fff" >{{item.title}}</span>
            </template>

          </span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import actions from '@/shared/actions';
import microAppManager from '@/utils/microAppManager';
import store  from '@/store';
import {ACCESS_TOKEN, logout, UI_CACHE_DB_DICT_DATA} from "@/store/commonExport";
import Vue from "vue";
export default {
  name:'sideMenu',
  props:['sideMenus','collapsed',],
  data() {
    return {
      selectedKeys:'Home',
      loadingApps: new Set() // 跟踪正在加载的应用
    };
  },
  computed: {
    microApps() {
      const microAppsStr = sessionStorage.getItem('microApps')
      return microAppsStr ? JSON.parse(microAppsStr) : []
    }
  },
  watch: {},
  mounted(){
    actions.onGlobalStateChange((state, prevState) => {
      // state: 变更后的状态; prevState: 变更前的状态
      // console.log("主应用观察者：token 改变前的值为 ", prevState);
      // console.log("主应用观察者：登录状态发生改变，改变后的 token 的值为 ", state);
    })
  },
  methods: {
    async changeMenu(item) {
      console.log('侧边点击事件',item,item.path.indexOf('http') !== -1);

      if(item.key == 'Home'){
        return false
      }

      if(item.path.indexOf('http') !== -1){
        window.open(item.path)
        return
      }

      const { key, id } = item;
      const microApp = this.microApps.find(app => key === app.name);

      if (!microApp) {
        this.$message.warning(`未找到应用 ${key} 的配置信息`);
        return
      }

      // 如果正在加载，避免重复加载
      if (this.loadingApps.has(key)) {
        console.log(`应用 ${key} 正在加载中，请稍候`);
        return
      }

      try {
        // 显示loading状态
        store.commit('showLoading')
        this.loadingApps.add(key)

        // 设置全局状态
        actions.setGlobalState({id})
        this.selectedKeys = key //侧边显示的一直是首页
        sessionStorage.setItem('menusId',id)
        sessionStorage.setItem('selectKey',key)

        // 更新当前菜单
        this.$store.commit('updataCurrentMenus',key)

        // 判断，如果顶部菜单有，则直接跳，没有则添加
        let menusflag = this.$store.state.home.menus.find(menuItem => key === menuItem.key);
        if(!menusflag){
          this.$store.commit('updataMenus',item)
        }

        // 使用微应用管理器加载应用
        console.log(`开始加载微应用: ${key}`)
        const app = await microAppManager.loadMicroApp(microApp, {
          singular: false,
        })

      } catch (error) {
        console.error(`微应用 ${key} 加载失败:`, error)

        // 清理错误状态
        this.$root.clearLoadError()
      } finally {
        // 移除加载状态
        this.loadingApps.delete(key)
        store.commit('hideLoading')
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 侧边菜单
.cns-menu-side {
  height: 100%;
  padding-bottom:40px;
    -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
  .cns-menu:not(.cns-menu-horizontal) .cns-menu-item-selected {
    border-radius: 0;
  }
  .cns-menu-item {
    width: 100%;
    color: #222;
    height: 40px;
    line-height: 40px;
    padding-left:30px!important;
  }
  .cns-menu-item-selected, .cns-menu-submenu-popup .cns-menu-item-selected {
    background-color: #fff;
  }
  .cns-menu,
  .cns-menu-inline,
  .cns-menu-sub{
    display: block!important;
  }
  .cns-menu-sub{
    display: block!important;
  }
  .cns-menu:not(.cns-menu-horizontal) .cns-menu-item-selected {
    background-color: none;
    // background-color: #fff;
    border-radius: 0;
  }
  .cns-menu:not(.cns-menu-horizontal) .cns-menu-item-selected {
    background-image: linear-gradient(to right, #D9E6FF, #fff);
    // background: #447FFB;
    color: #1660FD;
  }

  .cns-menu-item{
    border-radius: 0;
    margin-top:0px;
  }
  .cns-menu-side .cns-menu:not(.cns-menu-horizontal) .cns-menu-item-selected{
    background-image: linear-gradient(to right, red , yellow);
  }
}
.cns-menu,
  .cns-menu-inline,
  .cns-menu-sub{
    display: block!important;
  }
</style>

